<template>
    <!--
      Reusable file-type glyph. Resolves a document's MIME/type string to the
      shared SVG asset (PDF / Word / image) used across the app, so the same
      icon language is reused wherever documents are listed — the DocumentsPicker,
      the DocumentViewer, DocumentCard, etc. Renders only the <img>; callers own
      whatever chip/surface wraps it, since those sizes and tints vary per surface.
    -->
    <img
        :src="src"
        class="fileTypeIcon"
        :width="size"
        :height="size"
        loading="lazy"
        decoding="async"
        alt=""/>
</template>

<script>
import GenericFunctions from '@/utilities/GenericFunctions';

export default {
    name: 'FileTypeIcon',
    props: {
        // MIME type ('application/pdf') or backend Type label ('PDF' | 'Image' | …)
        type: {
            type: String,
            required: true
        },
        // Rendered glyph size in px (square).
        size: {
            type: Number,
            required: false,
            default: 18
        }
    },
    computed: {
        src(){
            return GenericFunctions.GetFileIconSrc(this.type);
        }
    }
}
</script>

<style scoped>
.fileTypeIcon {
    display: block;
    object-fit: contain;
}
</style>
